__webpack_require__.p = "https://app.cargoyard.co/dist/";